import { render, staticRenderFns } from "./addaccessory.vue?vue&type=template&id=7cf968de&scoped=true"
import script from "./addaccessory.vue?vue&type=script&lang=js"
export * from "./addaccessory.vue?vue&type=script&lang=js"
import style0 from "./addaccessory.vue?vue&type=style&index=0&id=7cf968de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf968de",
  null
  
)

export default component.exports